import { SapSuppliers } from "../../features"

const SapSuppliersPage = () => {
  return <SapSuppliers />
}

export default SapSuppliersPage
